import React from 'react'
import { connect } from 'react-redux'
import { t } from 'ttag'
import Cookie from 'js-cookie'

const ComparisonRegionSelector = ({ onSelectRegion, regions, defaultRegion }) => {
  const onClickFn = (regionId, doDelete) => () => {
    if (doDelete) {
      Cookie.remove('lmiComparisonLocation')
    } else {
      Cookie.set('lmiComparisonLocation', regionId)
    }

    onSelectRegion(doDelete ? null : regionId)
  }
  const selectedRegion = Cookie.get('lmiComparisonLocation')

  return (
    <div className="row" id="comparison-region-selector">
      <div className="col-xs-12">
        {defaultRegion && (
          <p className="default-region">
            <i className="fal fa-map-marker" aria-hidden="true"></i>{' '}
            {t`Site Default Region:`}
            <a
              href="javascript:void(0)"
              onClick={onClickFn(defaultRegion.id, selectedRegion === defaultRegion.id)}>
              {defaultRegion.name}
            </a>
          </p>
        )}
        <ul>
          {regions
            .sort((a, b) => {
              if (a.name < b.name) {
                return -1
              }

              if (a.name > b.name) {
                return 1
              }

              return 0
            })
            .map(r => (
              <li key={r.id} className="col-xs-3">
                <a
                  href="javascript:void(0)"
                  className={selectedRegion === r.id ? 'selected' : ''}
                  onClick={onClickFn(r.id, selectedRegion === r.id)}>
                  {selectedRegion === r.id ? (
                    <span>
                      <i className="fal fa-times hover-only"></i>
                      <i className="fal fa-check hover-hidden"></i>
                    </span>
                  ) : null}
                  {r.name}
                </a>
              </li>
            ))}
        </ul>
        <br className="clear" />
      </div>
    </div>
  )
}

export default connect(
  state => {
    return {
      ...state.lmiRegions
    }
  },
  dispatch => ({})
)(ComparisonRegionSelector)
